import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import classes from './styles.module.scss';
import { useParams } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import { adminTabs } from '../../consts/navigation.conts';
import { useKato } from '../../contexts/kato.context';
import GeneralInfoTab from './tabs/general-info-tab.component';
import { KatoType } from '../../types/kato.types';
import SelfSufficiencyTab from './tabs/self-sufficiency-tab.component';
import SerTab from './tabs/ser-tab.component';
import InfrastructureTab from './tabs/infrastructure-tab.component';
import PopulationDynamicTab from './tabs/population-dynamic-tab.component';
import TaxTab from './tabs/tax-tab.component';
import ScreeningTab from './tabs/screening-tab.components';
import RoadTab from './tabs/road-tab.component';
import InfrastructureProjectsTab from './tabs/infrastructure-projects-tab.component';
import ProjectDetails from './components/project-details.component';
import { useUser } from '../../contexts/user.context';
import InvestmentProjectsList from './tabs/investment-projects-list.component';
import ImprovementProjectsList from './tabs/improvement-projects-list.component';
import BudgetInvestmentTab from './tabs/budget-investment-tab.component';
const baseClass = 'edit-item-page';
const translationKey = `settings-config`;

const EditItemPage = () => {
  const { t } = useTranslation();
  const { currentLevel } = useKato();
  const { kato, link, id, tab } = useParams<{
    kato: string;
    link: string;
    id: string;
    tab: string;
  }>();
  const [tabs, setTabs] = useState<string[]>(adminTabs);
  const { isModulePresent, modules } = useUser();

  useEffect(() => {
    if (kato) {
      let filtered: string[] = [];
      if (currentLevel === KatoType.OBLAST) {
        filtered = adminTabs.filter((tab) => tab !== 'road');
      } else if (currentLevel === KatoType.REGION) {
        filtered = adminTabs;
      } else if (
        currentLevel === KatoType.DISTRICT ||
        currentLevel === KatoType.VILLAGE
      ) {
        const initial = [
          'general-info',
          'self-sufficiency',
          'population-dynamic',
          'infrastructure',
          'screening',
          'budget-investment-projects',
          'infrastructure-projects',
          'SNP_INVESTMENT',
          'SNP_IMPROVEMENT',
        ];
        filtered = initial;
      } else {
        filtered = adminTabs;
      }
      filtered = filtered.filter(
        (tab) => isModulePresent(tab) || tab === 'general-info',
      );
      setTabs(filtered);
    }
  }, [currentLevel, kato, modules]);

  return (
    <div className={classes[baseClass]}>
      <div className={classes[`${baseClass}__tabs`]}>
        {tabs.map((tab) => (
          <NavLink
            key={tab}
            to={`/admin/${kato}/${tab}`}
            className={({ isActive }) =>
              isActive
                ? `${classes[`${baseClass}__tab--active`]} ${classes[`${baseClass}__tab`]}`
                : classes[`${baseClass}__tab`]
            }
          >
            {t(`${translationKey}.${tab}`, { point: t(`of-${currentLevel}`) })}
          </NavLink>
        ))}
      </div>
      <div className={classes[`${baseClass}__content`]}>
        {link === 'general-info' && <GeneralInfoTab />}
        {link === 'self-sufficiency' && <SelfSufficiencyTab />}
        {link === 'ser' && <SerTab />}
        {link === 'infrastructure' && <InfrastructureTab />}
        {link === 'population-dynamic' && <PopulationDynamicTab />}
        {link === 'tax' && <TaxTab />}
        {link === 'budget-investment-projects' && <BudgetInvestmentTab />}
        {link === 'screening' && <ScreeningTab />}
        {link === 'road' && <RoadTab />}
        {link === 'infrastructure-projects' && !id && (
          <InfrastructureProjectsTab />
        )}
        {link === 'infrastructure-projects' && id && <ProjectDetails />}
        {link === 'SNP_INVESTMENT' && !tab && <InvestmentProjectsList />}
        {link === 'SNP_INVESTMENT' && tab && <ProjectDetails />}
        {link === 'SNP_IMPROVEMENT' && !tab && <ImprovementProjectsList />}
        {link === 'SNP_IMPROVEMENT' && tab && <ProjectDetails />}
      </div>
    </div>
  );
};

export default EditItemPage;
